module.exports = __webpack_public_path__ + "img/buidling-green.b7d5628e.png";